import { useMutation } from '@tanstack/react-query';
import { apiFetch } from 'utils/apiUtils.ts';
import useAuth from 'hooks/useAuth.ts';

interface LockIterationResponse {
  message?: string;
}

interface LockIterationVariables {
  teamId: string;
  campaignId: string;
  iterationId: string;
  newState: 'locked' | 'unlocked';
}

const getUrlPath = (
  teamId: string,
  campaignId: string,
  iterationId: string,
  newState: 'locked' | 'unlocked',
): string => {
  const baseUrl = `team/${teamId}/campaign/${campaignId}/iteration/${iterationId}`;
  const transition = newState === 'locked' ? 'lock' : 'unlock';

  return `${baseUrl}/${transition}`;
};

export default function useLockIteration() {
  const { tokens } = useAuth();

  return useMutation({
    mutationFn: async ({
      teamId, campaignId, iterationId, newState,
    }: LockIterationVariables) => {
      const path = getUrlPath(teamId, campaignId, iterationId, newState);

      return apiFetch<LockIterationResponse>({
        path,
        method: 'PUT',
        accessToken: String(tokens.accessToken),
      });
    },
  });
}
